import React, {useMemo} from "react";
import {QuotesListsItemsDataGridCellKeys} from "../../../../../../../../../core/constants/table/data-grid-column-keys";
import {DataGridColumnAlignments, DataGridColumnTypes} from "../../../../../../../../../packages/data-grid";
import IconButton from "../../../../../../../../components/base/button/icon_button";
import {OpenInNew} from "@mui/icons-material";
import PartnerDataGrid, {useDataGridSavedState} from "../../../../../../../../containers/data-grid";
import useAccessLevels from "../../../../../../../../hooks/use-access-levels";
import {CircularProgress, SvgIcon} from "@mui/material";
import ProductInformationPopover from "../../../../../../../../components/app-specific/draggable-popover/product-information-popover";
import {ReactComponent as Printer} from "../../../../../../../../../assets/images/printer.svg";


const QuotesListViewItemsTable = ({
                                      searchData,
                                      exportToCsv,
                                      data,
                                      dataGridSaveConfig,
                                      fetchingOrdersCustomer,
                                      navigateToInformationView,
                                      navigateToPrintView,
                                  }) => {
    const operatorAccessLevels = useAccessLevels();

    const columns = useMemo(() =>
        /** @type {DataGridColumn[]}*/
        [
            ...(operatorAccessLevels.packages.sales.quoteInformation ? [
                {
                    name: QuotesListsItemsDataGridCellKeys.navigate,
                    alignment: DataGridColumnAlignments.center,
                    type: DataGridColumnTypes.element,
                    pinned: true,
                    sortable: false,
                    pinnedToggleable: false,
                    resizable: false,
                    visibilityToggleable: false,
                    width: 0,
                },
                ...(operatorAccessLevels.packages.bizPrint.printQuote ? [
                    {
                        name: QuotesListsItemsDataGridCellKeys.print,
                        alignment: DataGridColumnAlignments.center,
                        type: DataGridColumnTypes.element,
                        pinned: true,
                        sortable: false,
                        pinnedToggleable: false,
                        resizable: false,
                        visibilityToggleable: false,
                        width: 0,
                    },
                ] : []),
            ] : []),
            {
                title: "Order No",
                name: QuotesListsItemsDataGridCellKeys.orderNo,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                pinned: true,
            },
            {
                title: "Customer",
                name: QuotesListsItemsDataGridCellKeys.customer,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
            },
            {
                title: "Part No",
                name: QuotesListsItemsDataGridCellKeys.partNo,
                alignment: DataGridColumnAlignments.center,
                type: DataGridColumnTypes.element,
            },
            {
                title: "Order Date",
                name: QuotesListsItemsDataGridCellKeys.submitDate,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.date,
            },
            {
                title: "Unit Price",
                name: QuotesListsItemsDataGridCellKeys.unitPrice,
                alignment: DataGridColumnAlignments.right,
                type: DataGridColumnTypes.money,
            },
            {
                title: "Order Qty",
                name: QuotesListsItemsDataGridCellKeys.orderQty,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.number,
            },
        ], [operatorAccessLevels.packages.bizPrint.printQuote, operatorAccessLevels.packages.sales.quoteInformation])

    const [dataGridColumns, , , dataGridDensity] = useDataGridSavedState({
        columns: columns,
        version: dataGridSaveConfig.version,
        name: dataGridSaveConfig.name,
    });

    /**@type {DataGridRow[]}*/
    const dataGridRows = useMemo(() => {
        return data?.map(item => ({
            key: item.id,
            data: item,
            cells: {
                [QuotesListsItemsDataGridCellKeys.navigate]:
                    <IconButton
                        color={'secondary'}
                        disabled={fetchingOrdersCustomer.includes(item.orderId)}
                        onClick={() => navigateToInformationView(item.customer, item.orderId)}
                    >
                        {
                            fetchingOrdersCustomer.includes(item.orderId)
                                ? <CircularProgress size={20} color={'secondary'}/>
                                : <OpenInNew className='icon normal'/>
                        }
                    </IconButton>,
                [QuotesListsItemsDataGridCellKeys.print]:
                    <IconButton
                        disabled={fetchingOrdersCustomer.includes(item.orderId)}
                        color={'paper.secondary'}
                        onClick={() => navigateToPrintView(item.customer, item.orderId)}
                    >
                        {
                            fetchingOrdersCustomer.includes(item.orderId)
                                ? <CircularProgress size={20} color={'secondary'}/>
                                : <SvgIcon className='icon medium' component={Printer}/>
                        }
                    </IconButton>,
                [QuotesListsItemsDataGridCellKeys.orderNo]: item.orderNo,
                [QuotesListsItemsDataGridCellKeys.customer]: item.customer?.name,
                [QuotesListsItemsDataGridCellKeys.partNo]:
                    <ProductInformationPopover partNo={item.partNo}>
                        {item.partNo ?? ""}
                    </ProductInformationPopover>,
                [QuotesListsItemsDataGridCellKeys.submitDate]: item.createdDate,
                [QuotesListsItemsDataGridCellKeys.unitPrice]: item.unitPrice,
                [QuotesListsItemsDataGridCellKeys.orderQty]: item.orderQty,
            }
        }))
    }, [data, fetchingOrdersCustomer, navigateToInformationView, navigateToPrintView]);

    return (
        <>
            <PartnerDataGrid
                {...dataGridSaveConfig}
                columns={dataGridColumns}
                initialLayoutState={{
                    columns: columns,
                }}
                rows={dataGridRows}
                state={{
                    pagination: searchData.paginationInfo,
                    sortBy: searchData.orderBy,
                    loading: {state: searchData.loading},
                    density: dataGridDensity,
                }}
                hideFooterActions
                getExportInfo={exportToCsv}
                onSortByChanged={(_, current) => searchData.setOrderBy(current)}
                onCurrentPageChanged={(_, current) => searchData.setPaginationInfo(prevState => ({...prevState, ...current}))}
                onPageSizeChanged={(_, current) => searchData.setPaginationInfo(prevState => ({...prevState, ...current}))}
            />
        </>
    );
}
export default QuotesListViewItemsTable;
